'use client';
import { Button } from '@/src/features/ui/button/button';
import { SortIcon } from '@/src/features/ui/icons/icons';
import classNames from 'classnames';
import useSorting from '@/src/hooks/use-sorting';

const triggerMobilSelect = () => {
  const select = document.querySelector('select');
  if (select) {
    select.click();
  }
};

interface SortingProps {
  orderList: { label: string; value: string }[];
  defaultValue?: string;
  className?: string;
}

export const Sorting: React.FC<SortingProps> = ({ orderList, defaultValue = '0', className, ...rest }) => {
  const { optionValue, handleChange } = useSorting(defaultValue);

  return (
    <div {...rest} className={className} data-testid="sortFilter">
      <Button
        onClick={triggerMobilSelect}
        text="Sırala"
        isNegative={true}
        paleButton={true}
        className="hidden h-[40px] w-[165px] rounded-lg border-black100 text-sm md:text-base"
        data-testid="sortButton"
      >
        <SortIcon width={20} height={20} className="purple500Svg mr-1" data-testid="sortIcon" />
      </Button>
      <div className="w-[165px] md:h-auto md:w-auto">
        <select
          className={classNames(
            'h-10 w-[165px] rounded-lg border border-black300 px-5 text-sm text-black1000 md:h-[48px] md:w-[224px]'
          )}
          value={optionValue}
          onChange={handleChange}
          data-testid="sort"
        >
          {orderList.map(({ value, label }) => (
            <option value={value} key={value} data-testid="sortOption">
              {label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
